import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from './TableHead'
import PureAdmin from './PureAdmin'
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';

class TableAdmin extends React.Component {
  constructor(props){
      super(props);
      this.state = {
      }
    }

    renderAdmin = () => {
      return (
        this.props.admin.map((admin, index) => (
        <PureAdmin intl={this.props.intl} refParent={this.props.refParent} deleting={this.props.deleting} admin={admin} key={admin.Id} index={index}/>
      ))
      )
    }

 render() {
   return (
     <Table>
      <TableHead />
      {
        this.props.admin.length === 0  && this.props.loadingAdmin === false?
        <TableBody>
          <TableRow>
            <TableCell  colSpan={"5"}>
              <Container fluid>
                <Row>
                  <Col xl={12} lg={12} md={12} sm={12} style={{display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 3}}>
                    <p style={{color: 'black', fontSize: '1.2rem', fontWeight: 'bold'}}>Pas de résultat</p>
                  </Col>
                </Row>
              </Container>
            </TableCell>
          </TableRow>
        </TableBody>
        :
        <TableBody>
          {this.renderAdmin()}
        </TableBody>
      }

    </Table>
   )
 }
}


export default TableAdmin;
